import { combineReducers } from 'redux';
import { createResponsiveStateReducer } from 'redux-responsive';
import { connectRouter } from 'connected-react-router';

// global store
import feedback from 'src/store/feedback/slices';
import client from 'src/store/client/reducers';
import logo from 'src/store/logo/reducers';
import menu from 'src/store/menu/slice';
import payment from 'src/store/payment/reducer';
import enqueue from 'src/store/enqueue/reducers';
import headerWidget from 'src/store/headerWidget/reducers';
import wishlist from 'src/store/wishlist/slice';
import bannerAppData from 'src/store/appBanners/slice';
import headerBanner from 'src/store/headerBanner/slice';
import tourists from 'src/store/tourists/slice';

import actualization from 'checkout/store/reducers/actualization';
import data from 'checkout/store/reducers/data';
import error from 'checkout/store/domains/error';
import hotel from 'checkout/store/reducers/hotel';
import order from 'checkout/store/reducers/order';
import packageReducer from 'checkout/store/reducers/package';
import services from 'checkout/store/reducers/services';
import similarPackages from 'checkout/store/reducers/similar-packages';
import validation from 'checkout/store/reducers/validation';
import view from 'checkout/store/reducers/view';
import extraRooms from 'checkout/store/reducers/extra-rooms';
import roomPopup from 'checkout/store/domains/room-popup';
import partnerLoyalty from 'checkout/store/partnerLoyalty/slice';
import packageUpsaleOptions from 'checkout/store/domains/package-upsale-options/slice';
import touristsCheckoutValidation from 'checkout/store/domains/tourists-checkout-validation/slice';
import touristsValidation from 'src/store/touristsValidation/slice';
import { reducer as packagePrebook } from 'checkout/store/domains/package-prebook';
import { reducer as visa } from 'checkout/store/domains/visa';
import flights from 'checkout/CheckoutRoutes/PackageCheckout/store/flights/slice';
import flightsFilters from 'checkout/CheckoutRoutes/PackageCheckout/store/flights-filters/slice';
import testimonials from 'checkout/CheckoutRoutes/PackageCheckout/store/testimonials/slice';
import actualizeAlternatives from 'checkout/CheckoutRoutes/PackageCheckout/store/actualize-alternatives/slice';
import roomInfo from 'src/routes/Checkout/store/domains/room-info';
import customer from 'checkout/store/domains/customer/slice';

const rootReducer = (history) =>
  combineReducers({
    // есть
    feedback,
    // есть
    client,
    // есть
    logo,
    // есть
    menu,
    // есть
    payment,
    // есть
    enqueue,
    // есть
    headerWidget,
    // есть
    wishlist,
    // есть, но лучше проверить
    touristsValidation,
    // есть
    tourists,
    // есть
    browser: createResponsiveStateReducer({
      small: 694,
      medium: 960,
      large: 1270,
      extraLarge: 1600,
    }),
    // есть
    router: connectRouter(history),
    // есть
    flights,
    // есть
    flightsFilters,
    // есть
    actualization,
    // есть
    order,
    // есть
    data,
    // есть
    validation,
    // есть
    view,
    // есть
    hotel,
    // есть
    testimonials,
    // есть
    roomInfo,
    // есть
    package: packageReducer,
    // есть
    services,
    // есть
    similarPackages,
    // есть
    visa,
    // есть
    error,
    // есть
    extraRooms,
    // есть
    roomPopup,
    // есть
    packageUpsaleOptions,
    // есть
    touristsCheckoutValidation,
    // есть
    packagePrebook,
    // есть
    actualizeAlternatives,
    // есть
    partnerLoyalty,
    // есть
    bannerAppData,
    // есть
    headerBanner,
    customer,
  });

export default rootReducer;
